import React, { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';
import { useHover } from '@rio-cloud/rio-uikit';
import { useComponentRegistry } from './ComponentRegistryContext';
import { FAVORITES_UPDATED_EVENT, FAVOURITE_FILTERS_KEY } from './constants';

interface HeartWrapperProps {
    children: React.ReactNode;
}

const HeartWrapper: React.FC<HeartWrapperProps> = ({ children }) => {
    const ref = useRef<HTMLDivElement>(null);
    const isHovered = useHover(ref);
    const { registerComponent } = useComponentRegistry();

    const firstChild = React.Children.toArray(children)[0];
    const childId = React.isValidElement(firstChild) && firstChild.props?.name ? firstChild.props.name : 'unknown';

    const favourites = JSON.parse(localStorage.getItem(FAVOURITE_FILTERS_KEY) || '[]');
    const isFavourited = favourites.includes(childId);
    useEffect(() => {
        registerComponent(childId, children);
    }, []);

    const handleHeartClick = () => {
        const updatedFavourites = JSON.parse(localStorage.getItem(FAVOURITE_FILTERS_KEY) || '[]');
        if (updatedFavourites.includes(childId)) {
            const filtered = updatedFavourites.filter((id: string) => id !== childId);
            localStorage.setItem(FAVOURITE_FILTERS_KEY, JSON.stringify(filtered));
        } else {
            updatedFavourites.push(childId);
            localStorage.setItem(FAVOURITE_FILTERS_KEY, JSON.stringify(updatedFavourites));
        }

        // Dispatch custom event to notify other components
        window.dispatchEvent(new CustomEvent(FAVORITES_UPDATED_EVENT));
    };

    return (
        <div ref={ref}
             className='heart-wrapper display-flex align-items-center hover-bg-decent padding-left-10 padding-right-10'>
            <div className="flex-1-1">{children}</div>
            <OverlayTrigger
                placement='top'
                overlay={
                    <Tooltip id='heart-tooltip'>
                        <FormattedMessage 
                            id={isFavourited ? 'intl-msg:unmarkAsFavourite' : 'intl-msg:markAsFavourite'} 
                            defaultMessage={isFavourited ? 'Unmark as favourite' : 'Mark as favourite'}
                        />
                    </Tooltip>
                }
            >
                <span
                    className={`rioglyph rioglyph-heart heart-icon flex-0 padding-left-10 transition-duration-03 ${isFavourited || isHovered ? 'opacity-100' : 'opacity-0'}`}
                    onClick={handleHeartClick}
                    style={{
                        pointerEvents: 'auto',
                        cursor: 'pointer'
                    }}
                />
            </OverlayTrigger>
        </div>
    );
};

export default HeartWrapper;
